import { put, takeLatest } from 'redux-saga/effects'
import { Action } from 'redux'
import { rootActions } from '@app-store/slices'
import axios, { getParams } from '@utils/request'
import { IListByGroupPayload } from '@app-store/slices/matchLists/listByGroup'

interface TaskAction extends Action {
    payload: IListByGroupPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.matchLists.listByGroup

function* listByGroupSagaTask({ payload }) {
    const params = yield getParams(payload)

    try {
        const response = yield axios.get(`/companies/match-lists/match-group/${payload.matchListGroupId}`, {
            params
        })
        if (response.success) {
            yield put(onSuccess(response.result))
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* listByGroupSaga(): any {
    yield takeLatest<TaskAction>(onRequest, listByGroupSagaTask)
}

export default listByGroupSaga
